import React from 'react';
import { Filter, ReferenceInput, SelectInput, TextInput } from 'react-admin';

const ArtistsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    {(props.permissions === 'MASTER_ADMIN' || props.permissions === 'ADMIN') && (
      <ReferenceInput
        label="Provider"
        source="provider_id"
        reference="users"
        sort={{ field: 'id', order: 'ASC' }}
        fullWidth
      >
        <SelectInput optionText={(record) => `${record.first_name} ${record.last_name}`} />
      </ReferenceInput>
    )}
    <TextInput label="Last Name" source="last_name" allowEmpty />
    <TextInput label="First Name" source="first_name" allowEmpty />
    <TextInput label="Country" source="country" allowEmpty />
    <ReferenceInput
      label="Art Type"
      source="art_type_id"
      reference="art-types"
      sort={{ field: 'id', order: 'ASC' }}
      fullWidth
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

export default ArtistsFilter;
